import { DirectiveBase } from '../../angular-directive-base.directive';
import {IController} from 'angular';

export class TableController implements IController {
  public static $inject = ['$attrs', '$scope', '$element'];
  public filter: string;
  public showFilter: boolean;
  public enableMultiSelect: boolean;
  public filterCallback: Function;

  constructor(private $attrs, private $scope, private $element: JQuery) {
    this.filter = '';
    this.showFilter = false;
    this.enableMultiSelect = $attrs.multiple === '';

    $scope.$watch('vm.filter', () => {
      if (this.filter.length > 3) {
        this.submitFilter();
      }
    });

    $scope.$watch('vm.currentFilter', (newValue) => {
      if (newValue === '') {
        this.filter = '';
        this.showFilter = false;
      }
    });
  }
  /* tslint:disable */
  public $onInit = () => { };
  /* tslint:enable */
  /**
   * Displays or hides the table filter
   */
  public toggleFilter() {
    this.showFilter = !this.showFilter;
    if (!this.showFilter) {
      this.filter = '';
      this.filterCallback(this.filter);
    } else {
      this.$scope.$$postDigest(() => {
        $('input[name=filterText]').focus();
      });
    }
  }

  /**
   * Calls the filter callback function passing in the filter text
   */
  public submitFilter() {
    if (this.filterCallback) {
      this.filterCallback(this.filter);
    }
  }

  /**
   * A method that is used to get an array of body rows
   */
  public getBodyRows() {
    return Array.prototype.reduce.call(this.$element.find('tbody'), (result, tbody) => {
      return result.concat(this.getRows(tbody));
    }, []);
  }

  /**
   * A method that is used to get an individual row
   */
  public getRows(element) {
    return Array.prototype.filter.call(element.rows, (row) => {
      return row;
    });
  }
}